import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NotificationBase } from "../notifications/notification-base.component";

@Component({
  selector: "snackbar",
  templateUrl: "./snackbar.component.html",
  styleUrls: ["./snackbar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent extends NotificationBase {}
